import React from 'react';
import { UserPoolInfo } from 'api/StakingAPI';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { parseSREP } from 'structure/staking/utils/parseSREP';

type UserReputationProps = {
  userPoolInfo: UserPoolInfo;
};

export function UserReputation({ userPoolInfo }: UserReputationProps) {
  const { t } = useTranslation('common');
  const srep = parseSREP(userPoolInfo?.reputationScore || '0').toNumber();

  return (
    <Typography className='pt-px text-xs text-[#B4BCD0]'>
      {t('srep', { value: srep })}
    </Typography>
  );
}
